mobileSize = 800;

$(document).ready(function () {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $("body").addClass("saffireMobileSize").removeClass("saffireLargeSize");
  }
  if (windowSize > 801) {
    $("body").removeClass("saffireMobileSize");
  }

  // General Message
  $(".generalmessage").prependTo("header");
  // Custom Email Signup
  $(".homepage .emailSignup .emailSignupText").text("");

  // $(".homepage .emailSignup .emailInputField input").attr(
  //   "value",
  //   "Email Address"
  // );

  $(".homepage .emailSignup .emailInputField input").attr('placeholder', "Email Address")
  $(".homepage .emailSignup .emailInputField input").val('')
  

  $(".homepage .emailSignup .emailSubmitButton").text("Sign up");
    /////////////////////////////////
  $(".getUpdatesPageEmailModule .emailSignup .emailSignupText").text(
    "Enter your email to get exclusive rodeo updates!"
  );
  

  var lastScrollTop = 0;

  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();

    if (scrollTop > lastScrollTop) {
      $("#secondary-widgets-container").hide();
      $(".ticket-navbar").css("display", "block");
      $("header").addClass("header-small");
    } else {
      $("#secondary-widgets-container").show();
      $(".ticket-navbar").css("display", "none");
      $("header").removeClass("header-small");
    }

    lastScrollTop = scrollTop;
  });

  $(".mobile-menu-container").append('<div class="nav-collumn"><div class="contact-column"><div><p class="footer-title-info"><a href="">Contact Us</a></p></div><div class="contact-info-footer"><div class="footer-links-site"><li><span id="phone-icon"></span><a href="tel:7015906820">701-590-6820</a></li><li style="font-weight: 700"><span id="location-icon"><a href="https://www.google.com/maps/place/Killdeer+Saddle+Club+Arena/@47.371039,-102.8035958,15z/data=!4m6!3m5!1s0x532659e12650c5c1:0x33f0deab217dd9bf!8m2!3d47.371039!4d-102.8035958!16s%2Fg%2F11frdcfd6c"></span>311 ND-22 Bypass Killdeer ND 58640</a></li><li><span id="mail-icon"></span><a href="mailto:info@killdeersaddle.com">info@killdeersaddle.com</a></li></div></div></div><div class="footer-collumn"><a href="https://www.killdeersaddleclub.com/"><div class="sponsored-by">Copyright © 2022 Killdeer Saddle Club. @ All Rights Reserved. </div></a><a href="https://www.saffire.com/"><div class="powered-by">powered-by</div></a></div></div>');

});

$(window).load(function () {
  $("body").addClass("pageIsLoaded");
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    var start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);

  
});

